<template>
    <div class="modal" :class="{ 'open_modal': allVideoModalShow}">
        <div class="modal_overlay"></div>
        <div class="modal_inner max_height_80">
            <div class="modal_header"> 
                <span class="close_icon close_icon_sm" @click="closeVideoModal()">×</span>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content modal_1080p">
                    <div class="row">
                        <div class="col_12">
                            <div class="custom_tabs">
                                <nav class="video_tabs">
                                    <ul class="">
                                        <template v-for="(video, index) in videos" :key="('key') + index">
                                            <li :href="'#videolist'+ (index+1)" :class="[{'active' : isOpen === 'key_'+index}]" @click="changeTab(index)"> Video {{ index + 1 }} </li>
                                        </template>
                                    </ul>
                                </nav>
                                <div class="tab_content_wrapper">
                                    <div class="custom_tab_content_inner">
                                        <template v-if="videos.length">
                                            <template v-for="(video, index) in videos" :key="('key') + index">
                                                <div :id="'videolist' + (index+1)" class="video_tab_content" :class="[ {'show' : isOpen === 'key_'+index }]">
                                                    <div class="fadein">
                                                        <div class="upload_content_inner">
                                                            <div id="video_wrap">
                                                                <a role="button" :class="['cursor_pointer play_button', {'d_none': videoPlaying}]" @click.prevent="playVideo(video)">
                                                                    <img :src="`${baseUrl}assets/images/play.png`" alt="">
                                                                </a>
                                                                <VideoIntro
                                                                    :videoPlaying="videoPlaying"
                                                                    :currentPlayerTime="currentPlayerTime"
                                                                    :player="player"
                                                                    :videoIntro="video.video_intro"
                                                                />
                                                                <div class="player_wrap" :id="'player_wrap_'+index">
                                                                    <video :id="`player_${index}`" class="video-js vjs-default-skin" controls playsinline> </video>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VideoIntro from "@/components/shared/VideoIntroComponent.vue";

    export default {
        name:'all-video-modal',
        components: {VideoIntro},
        emits: ["closeModal"],
        data(){
            return{
                baseUrl: process.env.VUE_APP_BASE,
                btnClose: true,
                videoPlaying: false,
                player: null,
                videoSmilFile: '',
                isOpen : 'key_0',
                currentTab: 0,
                currentPlayerTime: null
            }
        },
        props:{
            allVideoModalShow:{
                type: Boolean,
                required: true
            },
            videos:{
                type: Array,
                required: false
            }
        },
        created(){
            // console.log(this.videos)
        },
        methods:{
            playVideo(video){
                // console.log(this.player)
                // if(this.player) {
                //     console.log('k')
                //     this.player.dispose()
                //     this.videoPlaying = false;
                // }
                this.videoSmilFile = '';
                if(video.smil){
                    this.videoSmilFile = video.smil
                    this.initPlayer()
                }
            },
            initPlayer() {
                let self = this;
                setTimeout(()=>{
                    self.player = window.videojs('player_'+self.currentTab,{
                        inactivityTimeout: 0,
                        liveui: true,
                        liveTracker: true,
                        fluid: true,
                        controlBar: {
                            volumePanel: {
                                inline: false,
                                volumeControl: {
                                    vertical: true
                                }
                            }
                        }
                    });
                    this.player.volume(0.5);
                    self.player.ready(function() {
                        self.player.src([
                            {src: self.videoSmilFile, type: 'application/x-mpegURL'}
                        ]);
                        self.player.autoplay(false);
                        self.player.aspectRatio('16:9');
                        self.player.play()
                        self.player.on('timeupdate', function () {
                            self.currentPlayerTime = Math.floor(self.player.currentTime());
                        });
                        self.videoPlaying = true;
                    });
                }, 100)
            },
            closeVideoModal(){
                if (this.btnClose) {
                    if(this.player) { 
                        this.player.dispose()
                        this.videoPlaying = false;
                    }
                    this.$emit("closeModal");
                }
            },
            changeTab(index){
                this.currentTab = index
                if(this.player) { 
                    this.player.dispose()
                    this.videoPlaying = false;
                } 

                if("key_"+index != this.isOpen){
                    window.$(`#player_wrap_${index}`).empty()
                    window.$(`#player_wrap_${index}`).append(`<video id="player_${index}" class="video-js vjs-default-skin" controls playsinline> </video>`)
                    // this.initPlayer()
                    this.isOpen = "key_"+index;
                }
            }
        }
    }
</script>

<style scoped>
    .modal .modal_wrapper{
        overflow: hidden;
    }
    #video_wrap{
        position: relative;
        background: #000;
    }
    #video_wrap .play_button{
        left: 50%;
        position: absolute;
        z-index: 1;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    #video_wrap .video-js{
        position: relative;
        padding-top: 50%;
        background-color: #000 !important;
    }

    .modal_inner .close_icon{
        position: absolute;
        top: -15px;
        right: -15px;
        overflow: hidden;
        cursor: pointer;
        z-index: 5;
        padding: 0.2rem 0.62rem;
        box-shadow: 0px 4px 24px 0px rgb(34 41 47 / 10%);
        border-radius: 4px;
        background: #fff;
        font-size: 2rem;
        font-weight: 400;
        line-height: 1;
        transition: all 0.3s;
    }

    .custom_tabs .video_tabs ul li{
        cursor: pointer;
    }
</style>